/**
 * App-level maximize toggle.
 * Hides AdminLTE chrome (sidebar, navbar, breadcrumbs) and expands
 * the [data-maximize-content] container to fill the entire viewport.
 *
 * Usage:
 *   <button data-maximize-toggle>...</button>
 *   <div data-maximize-content>...</div>
 *
 * No JS initialization needed -- auto-discovered on page load.
 * Esc key exits maximized mode.
 */

const BODY_CLASS = 'app-maximized';
const ICON_EXPAND = 'fa-expand';
const ICON_COMPRESS = 'fa-compress';

function toggle(button) {
    const body = document.body;
    const isMaximized = body.classList.toggle(BODY_CLASS);

    // Update button icon and tooltip
    const icon = button.querySelector('i, .fas, .fa, .fa-solid');
    if (icon) {
        icon.classList.toggle(ICON_EXPAND, !isMaximized);
        icon.classList.toggle(ICON_COMPRESS, isMaximized);
    }
    button.title = isMaximized ? 'Obnovit zobrazení' : 'Maximalizovat zobrazení';
}

function init() {
    // Delegate click on any data-maximize-toggle button
    document.addEventListener('click', (e) => {
        const button = e.target.closest('[data-maximize-toggle]');
        if (button) {
            toggle(button);
        }
    });

    // Esc to exit
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && document.body.classList.contains(BODY_CLASS)) {
            const button = document.querySelector('[data-maximize-toggle]');
            if (button) {
                toggle(button);
            }
        }
    });
}

export { init };
